import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class extends Component {
	render() {
		return (
			<div className="vertical-center">
				<div className="container text-center">
					<h1>404 Not Found</h1>
					<Link to="/">Перейти на главную</Link>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js